module.exports = __webpack_public_path__ + "static/media/header_image_05.c2f27e53.jpg";